import { Dashboard_MarketingConsentsDialog } from 'features/shared/components/loaders/promiseLoadingAreas';
import PromiseLoadingSpinner from 'features/shared/components/loaders/PromiseLoadingSpinner';
import ModalFooter from 'features/shared/components/modal/ModalFooter';
import ModalHeader from 'features/shared/components/modal/ModalHeader';
import RenderWrapper from 'features/shared/components/renderWrapper/RenderWrapper';
import { UserEnumDTO } from 'features/shared/enums/dynamic/UserEnumDTO';
import { useForm } from 'features/shared/forms/hooks/useForm';
import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import MarketingConsentReactionDTO from '../dtos/MarketingConsentReactionDTO';

type Props = {
  show: boolean;
  consentTypes: UserEnumDTO[];
  onSubmit: (consents: MarketingConsentReactionDTO[]) => void;
  onClose: () => void;
}

const MarketingConsentsDialog = ({ show, consentTypes, onSubmit, onClose }: Props) => {
  // translations
  const { t } = useTranslation(["consents\\consents"]);

  // form-hook
  const { values, bindField, setFormValue } = useForm({initialValues: {}, initialValidations: {} }); 

  // side-effects
  useEffect(() => {
    // set default values
    for (const type of consentTypes) {
      setFormValue(type.code!, false);
    }
  }, [consentTypes])

  // handlers
  const submitFormHandler = async (e: React.FormEvent) => {
    e.preventDefault();
    
    let consentReactions: MarketingConsentReactionDTO[] = [];

    for (const [key, value] of Object.entries(values)) {
      consentReactions.push({
        code: key,
        consentGranted: value
      });
    }

    onSubmit(consentReactions);
  };

  const renderMarketingConsents = () => { 
    return consentTypes.map((item) => (
      <div className="custom-control custom-checkbox mb-3" key={item.code}>
        <input
          type="checkbox"
          className="custom-control-input"
          id={item.code}
          {...bindField(item.code!, true)}
        />
        <label 
          className="custom-control-label" 
          htmlFor={item.code}
          dangerouslySetInnerHTML={{ __html: item.name! }}
        />
      </div>
    ));
  }

  // render
  return (
    <Modal show={show} backdrop="static">
      <ModalHeader
        title={t("marketingConsentsDialog.dialogTitle")}
        onCloseClick={onClose}
      />
      <form onSubmit={submitFormHandler}>
        <div className="modal-body pt-4 px-4 pb-2">
          <RenderWrapper isVisible={() => t("marketingConsentsDialog.dialogInfoText") !== ""}>
            <p 
              className="pb-3 border-bottom text-muted"
              dangerouslySetInnerHTML={{
                __html: t("marketingConsentsDialog.dialogInfoText"),
              }}
            />
          </RenderWrapper>
          {renderMarketingConsents()}
        </div>
        <ModalFooter>
          <div className="row no-gutters align-items-center w-100">
            <RenderWrapper isVisible={() => t("marketingConsentsDialog.dialogFooterText") !== ""}>
              <div 
                className="col small pr-3"
                dangerouslySetInnerHTML={{
                  __html: t("marketingConsentsDialog.dialogFooterText"),
                }}
              />
            </RenderWrapper>
            <div className="col-auto ml-auto">
              <button type="submit" className="btn btn-primary">
                {t("marketingConsentsDialog.dialogSubmitButton")}
              </button>
            </div>
          </div>         
        </ModalFooter>
      </form>
      <PromiseLoadingSpinner area={Dashboard_MarketingConsentsDialog} />
    </Modal>
  );
}

export default MarketingConsentsDialog;